module.exports = __webpack_public_path__ + "img/guangGong6.bac50f65.png";